import React from "react";
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { Button } from "../../button/index";
import { FaCopy, FaTrash } from "react-icons/fa";
import InputMask from "react-input-mask";
import { InputBox } from "../../form/input.box/index";
import { Tooltip } from "../../tooltip/index";
import { Checkbox } from "../../form/checkbox";
import { DatePicker } from "../../form/date.picker.input";
import { FORMATS } from "@lib/common";
import { getWeekdayFromMomentISOIndex } from "@lib/common";
export class FieldSpecialHours extends React.Component {
    add = () => {
        const hours = [...this.props.hours];
        const date = this.props.intl.momentNow();
        hours.push({
            date: date.format(FORMATS.moment.date),
            day: getWeekdayFromMomentISOIndex(date.isoWeekday()),
            opened: true,
            open: "09:00",
            close: "21:00",
            h24: false,
        });
        this.props.onChange(hours);
    };
    copy = (i) => {
        const hours = [...this.props.hours];
        hours.splice(i, 0, { ...hours[i] });
        this.props.onChange(hours);
    };
    remove = (i) => {
        const hours = ([...this.props.hours]);
        hours.splice(i, 1);
        this.props.onChange(hours);
    };
    update = (i, update) => {
        const hours = [...this.props.hours];
        hours[i] = { ...hours[i], ...update };
        this.props.onChange(hours);
    };
    render() {
        const { hours, intl } = this.props;
        const { update, remove, copy } = this;
        return (React.createElement("div", null,
            React.createElement(Button, { color: "primary-inverse", size: "xs", type: "button", onClick: this.add }, "Add Special Hours Slot"),
            hours.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "flex-line m-t-4", style: { alignItems: "flex-end" } },
                    React.createElement(FormGroup, { style: { width: "150px" }, className: "m-b-0", title: "Date", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "75px" }, className: "m-b-0", title: "Opened", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "75px" }, className: "m-b-0", title: "24 Hour", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "100px" }, className: "m-b-0", title: "Open Time", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "100px" }, className: "m-b-0", title: "Close Time", small_title: true, no_border: true })),
                hours.map((h, i) => (React.createElement("div", { key: i, className: "flex-line", style: { alignItems: "flex-end" } },
                    React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                        React.createElement(FormGroup, { style: { width: "150px" }, className: "m-b-0", no_border: true },
                            React.createElement(DatePicker, { date: intl.momentFromFormat(h.date, FORMATS.moment.date).toDate(), displayFormat: intl.s.formats.date, locale: intl.s.locale, timezone: intl.s.tz, onSelect: (value) => {
                                    update(i, {
                                        date: value.date,
                                        day: getWeekdayFromMomentISOIndex(value.moment.isoWeekday()),
                                    });
                                } })),
                        React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                            React.createElement(InputBox, { className: "no-round flex-center width75" },
                                React.createElement(Checkbox, { id: `${i}-special-hours-opened-checkbox`, checked: h.opened, onChange: (e) => update(i, { opened: e.target.checked }) }))),
                        React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                            React.createElement(InputBox, { className: "no-round flex-center width75" },
                                React.createElement(Checkbox, { id: `${i}-24-special-hours-checkbox`, checked: h.h24, onChange: (e) => update(i, { h24: e.target.checked }) }))),
                        React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                            React.createElement(InputMask, { mask: "99:99", value: h.open, onChange: (e) => update(i, { open: e.target.value }), disabled: !h.opened || h.h24 }, (inputProps) => React.createElement(Input, { type: "text", className: "no-round", style: { width: "100px" }, placeholder: "00:00", ...inputProps, disabled: !h.opened || h.h24 }))),
                        React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                            React.createElement(InputMask, { mask: "99:99", value: h.close, onChange: (e) => update(i, { close: e.target.value }), disabled: !h.opened || h.h24 }, (inputProps) => React.createElement(Input, { type: "text", className: "no-round", style: { width: "100px" }, placeholder: "00:00", ...inputProps, disabled: !h.opened || h.h24 })))),
                    React.createElement(Tooltip, { text: "Copy", width: 65, position: "top", disable: i !== 0 },
                        React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => copy(i) },
                            React.createElement(FaCopy, null))),
                    React.createElement(Tooltip, { text: "Delete", width: 65, position: "top", disable: i !== 0 },
                        React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => remove(i) },
                            React.createElement(FaTrash, null))))))))));
    }
}
//# sourceMappingURL=index.js.map